import { render } from "./DocumentsView.vue?vue&type=template&id=266c5026&ts=true"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__